const GoodsReturnTab = () => {
  return <div>GoodsReturnTab</div>;
};

export default GoodsReturnTab;
